(function () {
  function initStickyAtc(sticky) {
    if (sticky.dataset.stickyInit === 'true') return;
    sticky.dataset.stickyInit = 'true';

    var section = sticky.closest('[data-section-id]') || document;
    var mainBtnId = sticky.getAttribute('data-main-add-target');
    var mainBtn = mainBtnId ? document.getElementById(mainBtnId) : null;
    if (!mainBtn) {
      mainBtn = section.querySelector('[data-add-to-cart]');
    }
    if (!mainBtn) return;

    var stickyBtn = sticky.querySelector('[data-sticky-atc-add]');
    var stickyLabel = sticky.querySelector('[data-sticky-atc-label]');
    var stickyPrice = sticky.querySelector('[data-sticky-atc-price]');
    var priceWrapper = section.querySelector('[data-price-wrapper]');

    // The bar lives off-screen via CSS transform; drop the [hidden] attr so it
    // can animate in/out.
    sticky.removeAttribute('hidden');

    // Show the bar only once the main add-to-cart has scrolled ABOVE the
    // viewport (i.e. the shopper has scrolled past it), not when it is still
    // below the fold on initial load.
    var observeTarget = mainBtn.closest('.product__submit__buttons') || mainBtn;

    function setVisible(visible) {
      sticky.classList.toggle('is-visible', visible);
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var scrolledPast = entry.boundingClientRect.top < 0;
            setVisible(!entry.isIntersecting && scrolledPast);
          });
        },
        { threshold: 0 }
      );
      observer.observe(observeTarget);
    } else {
      window.addEventListener(
        'scroll',
        function () {
          var rect = observeTarget.getBoundingClientRect();
          setVisible(rect.bottom < 0);
        },
        { passive: true }
      );
    }

    // Because products can have many variants, the sticky button does NOT add
    // to cart. It scrolls the shopper back to the top so they can choose
    // options and use the real add-to-cart button.
    stickyBtn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    // Keep the sticky bar's label + price in sync with the main product
    // block whenever the selected variant changes.
    function syncFromMain() {
      var mainText = mainBtn.querySelector('[data-add-to-cart-text]');
      if (mainText && stickyLabel) {
        stickyLabel.textContent = mainText.textContent.trim();
      }

      if (!priceWrapper || !stickyPrice) return;
      var priceEl = priceWrapper.querySelector('[data-product-price]');
      var compareEl = priceWrapper.querySelector('[data-compare-price]');
      var priceText = priceEl ? priceEl.textContent.trim() : '';
      var compareText = compareEl ? compareEl.textContent.trim() : '';
      var onSale =
        priceEl && priceEl.classList.contains('product__price--sale') &&
        compareText !== '';

      if (!priceText) return;

      if (onSale) {
        stickyPrice.innerHTML =
          '<span class="sticky-atc__price-compare"></span>' +
          '<span class="sticky-atc__price-sale"></span>';
        stickyPrice.children[0].textContent = compareText;
        stickyPrice.children[1].textContent = priceText;
      } else {
        stickyPrice.innerHTML = '<span class="sticky-atc__price-regular"></span>';
        stickyPrice.children[0].textContent = priceText;
      }
    }

    document.addEventListener('theme:variant:change', function () {
      // Let the theme update the main price/button first, then mirror it.
      window.requestAnimationFrame(syncFromMain);
    });
  }

  function init() {
    document.querySelectorAll('[data-sticky-atc]').forEach(initStickyAtc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
